import {useQueries} from "@tanstack/react-query";
import UsageRecordService from "../../../../services/web/usage-records-service.js";

const useFetchData = () => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['vehicles-available'],
                queryFn: () => UsageRecordService.getVehicle().then((res) => (res?.data ?? []).map(({ id, text }) => ({ value: id, label: text })))
            },
            {
                queryKey: ['conductors-list'],
                queryFn: () => UsageRecordService.getConductor().then((data) => (data ?? []).map(({ id, text }) => ({ value: id, label: text })))
            },
        ]
    });

    return {
        vehicles: queries[0].data ?? [],
        conductors: queries[1]. data ?? [],
    };
};

export default useFetchData;